export default __webpack_public_path__ + "static/media/back_icon.c2fdfbd6.svg";